import { render } from "./errorPage4.vue?vue&type=template&id=adbc5908&scoped=true"
const script = {}

import "./errorPage4.vue?vue&type=style&index=0&id=adbc5908&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adbc5908"]])

export default __exports__